import {
    REGISTRATION_KEYS_THAT_ALLOW_CHAIN_FIELD,
    REGISTRATION_KEYS_THAT_REQUIRE_AVAILABILITY,
    REGISTRATION_KEYS_THAT_REQUIRE_PICK_UP_ADDRESS,
} from '../types/registration-data'

export const getRequiresAvailability = (registrationKeys: string[]): boolean => {
    return registrationKeys.some((key) => REGISTRATION_KEYS_THAT_REQUIRE_AVAILABILITY.includes(key))
}

export const getRequiresPickupAddress = (registrationKeys: string[]): boolean => {
    return registrationKeys.some((key) => REGISTRATION_KEYS_THAT_REQUIRE_PICK_UP_ADDRESS.includes(key))
}

export const allowsChain = (registrationKeys: string[]): boolean => {
    return registrationKeys.some((key) => REGISTRATION_KEYS_THAT_ALLOW_CHAIN_FIELD.includes(key))
}
